<template>
  <div class="online-skincare-assessment">
    <b-container fluid>
      <b-row v-if="!validcode">
        <b-col cols="12" class="mycontainer-main m-borders">
          <div class="row h-100">
            <div class="col-sm-12 align-self-center text-center">
              <div class="mid">
                <div id="bar" class="bar pt-5"></div>
                <h2 class="">{{ $t("onlineassessment.title") }}</h2>
                <p class="" style="font-size: 1.2em">
                  {{ $t("onlineassessment.description") }}
                </p>

                <div class="row h-100 mt-5 main-assessment-img py-2">
                  <b-col
                    cols="12"
                    md="4"
                    class="align-self-center text-center px-2"
                  >
                    <h1>1</h1>
                    <h4 style="font-weight: bold; margin-top: -2vh">
                      {{ $t("onlineassessment.step1") }}
                    </h4>
                  </b-col>
                  <b-col cols="12" md="4" class="align-self-center text-center">
                    <h1>2</h1>
                    <h4 style="font-weight: bold; margin-top: -2vh">
                      {{ $t("onlineassessment.step2") }}
                    </h4>
                  </b-col>
                  <b-col cols="12" md="4" class="align-self-center text-center">
                    <h1>3</h1>
                    <h4 style="font-weight: bold; margin-top: -2vh">
                      {{ $t("onlineassessment.step3") }}
                    </h4>
                  </b-col>
                </div>
                <b-button
                  squared
                  style="background-color: black; min-width: 250px"
                  class="main-button fade-in my-5"
                  v-on:click="checkCode"
                  >{{ $t("onlineassessment.starteval") }}</b-button
                >
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-row v-else>
        <div class="col-sm-12">
          <div class="card-style">
            <b-progress :value="progress" squared variant="dark"></b-progress>
          </div>

          <div v-if="current_step == 1">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q1") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-form>
                  <b-form-input
                    id="input-1"
                    v-model="form.Picked.name"
                    required
                  ></b-form-input>
                  <!-- <b-form-checkbox-group v-model="form.Picked.consent" stacked  switches s class="mt-2" id="checkboxes-4">
                            <b-form-checkbox value="AgreeTerms">Agree to Terms & Conditions</b-form-checkbox>
                            <b-form-checkbox value="AgreeEmails">Receive Emails After Quiz</b-form-checkbox>
                          </b-form-checkbox-group> -->
                  <b-form-checkbox
                    v-model="form.Picked.terms"
                    class="mt-2"
                    switch
                    size="lg"
                  >
                    {{ $t("onlineassessment.terms") }}
                  </b-form-checkbox>
                  <b-form-checkbox
                    v-model="form.Picked.emails"
                    class="mt-2"
                    switch
                    size="lg"
                  >
                    {{ $t("onlineassessment.emails") }}
                  </b-form-checkbox>
                </b-form>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction1"
                  @click.prevent="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>

          <!-- this is the start of new question -->
          <div v-if="current_step == 2">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q2") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.productOptions"
                :key="x.id"
                :class="{ active: IsInList(x, form.Picked.products) }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="checkbox"
                    :id="x.id"
                    v-model="form.Picked.products"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}
                </b-button>
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction2"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 3">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q3") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.concernOptions"
                :key="x.id"
                :class="{ active: IsInList(x, form.Picked.concerns) }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="checkbox"
                    :id="x.id"
                    v-model="form.Picked.concerns"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction3"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 4">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q4") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.symptomOptions"
                :key="x.id"
                :class="{ active: IsInList(x, form.Picked.symptoms) }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="checkbox"
                    :id="x.id"
                    v-model="form.Picked.symptoms"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction4"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 5">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q5") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.regularRoutineOptions"
                :key="x.id"
                :class="{ active: form.Picked.regularRoutine == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.regularRoutine"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction5"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 6">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q6") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.satisfiedOptions"
                :key="x.id"
                :class="{ active: form.Picked.satisfied == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.satisfied"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction6"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 7">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q7") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.multipleBrandsOptions"
                :key="x.id"
                :class="{ active: form.Picked.multipleBrands == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.multipleBrands"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction7"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 8">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q8") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.buyingPatternOptions"
                :key="x.id"
                :class="{ active: form.Picked.buyingPattern == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.buyingPattern"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction8"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 9">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q9") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.activeIngrOptions"
                :key="x.id"
                :class="{ active: form.Picked.activeIngr == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.activeIngr"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction9"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 10">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q10") }}</h2>
                </div>
              </div>
            </b-row>
            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.applyOrderOptions"
                :key="x.id"
                :class="{ active: form.Picked.applyOrder == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.applyOrder"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 11">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.q11") }}</h2>
                </div>
              </div>
            </b-row>
            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div
                class="col-sm-3 align-self-center text-center mt-4"
                v-for="x in form.choosingProductOptions"
                :key="x.id"
                :class="{ active: form.Picked.choosingProduct == x.value }"
              >
                <label>
                  <img
                    :src="require(`@/assets/images/assessment/${x.imgURL}`)"
                    height="150px;"
                  />
                  <p>{{ x.text }}</p>
                  <input
                    type="radio"
                    :id="x.id"
                    v-model="form.Picked.choosingProduct"
                    :value="x.value"
                    style="display: none"
                  />
                </label>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  squared
                  class="float-right main-button"
                  style="background-color: black"
                  :disabled="buttonaction11"
                  @click="onClickNext"
                  >{{ $t("common.next") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <!-- this is the start of new question -->
          <div v-if="current_step == 12">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.age") }}</h2>
                </div>
              </div>
            </b-row>

            <b-row class="row mx-5" align-h="center">
              <!-- this is where you add choices -->
              <div class="col-sm-4 align-self-center text-center">
                <b-form-select
                  v-model="form.Picked.age"
                  :options="form.ageOptions"
                ></b-form-select>
              </div>
            </b-row>
            <b-row class="row mx-5 mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <h2>{{ $t("onlineassessment.email") }}</h2>
                <b-form-input
                  id="input-1"
                  v-model="form.Picked.email"
                  type="email"
                  required
                  :placeholder="$t('onlineassessment.enteremail')"
                ></b-form-input>
              </div>
              <!-- this is the end of the choices -->
            </b-row>
            <b-row class="row mx-5 mt-5" align-h="center">
              <div class="col-sm-8 align-self-center text-center">
                <h3>{{ $t("onlineassessment.result_message") }}</h3>
              </div>
            </b-row>

            <b-row class="row mt-5" align-h="center">
              <div class="col-sm-4 align-self-center text-center">
                <b-button
                  v-if="current_step > 1"
                  squared
                  class="float-left main-button"
                  variant="secondary"
                  @click="onClickBack"
                >
                  {{ $t("common.goback") }}</b-button
                >
                <b-button
                  v-if="current_step == 12"
                  squared
                  class="float-right main-button"
                  style="background-color: #36a8eb"
                  :disabled="buttonaction12"
                  @click="SubmitQuiz"
                  >{{ $t("common.submit") }}</b-button
                >
              </div>
            </b-row>
          </div>
          <!-- this is the end of new question -->

          <div v-if="submitting">
            <b-row class="row mt-5">
              <div class="col-sm-12 align-self-center text-center">
                <div>
                  <h2>{{ $t("onlineassessment.eval_transition") }}</h2>
                </div>
                <div><b-spinner label="Loading..."></b-spinner></div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import choiceToggle from "@/components/general/choiceToggle";
import { store, mutations } from "@/store/store.js";

const enOptions = {
  productOptions: [
    { text: "Cleanser", value: "cleanser", imgURL: "cleanser-01.jpg" },
    { text: "Toner", value: "toner", imgURL: "toner-01-01.jpg" },
    { text: "Serum", value: "serum", imgURL: "serum-01-01.jpg" },
    { text: "Day-Cream", value: "daycream", imgURL: "day-cream-01.jpg" },
    { text: "Night-Cream", value: "nightcream", imgURL: "day-cream-01.jpg" },
    { text: "Eye Cream", value: "eyecream", imgURL: "eye-cream-01.jpg" },
    { text: "Exfoliation", value: "exfoliation", imgURL: "exfoliation-01.jpg" },
    { text: "Mask", value: "mask", imgURL: "mask-01.jpg" },
  ],

  concernOptions: [
    { text: "Redness", value: "Redness", imgURL: "redness-01.jpg" },
    { text: "Imperfections / Acne", value: "Acne", imgURL: "acne-01_a.jpg" },
    { text: "Uneven skintone", value: "Uneven", imgURL: "uneven-01.jpg" },
    { text: "Wrinkles", value: "Wrinkles", imgURL: "wrinkles-01.jpg" },
    { text: "Dry Skin", value: "Dry", imgURL: "dry-skin-01.jpg" },
  ],

  symptomOptions: [
    {
      text: "Red when consuming alcohol",
      value: "Red when consuming alcohol",
      imgURL: "red_alcohol-01.jpg",
    },
    {
      text: "Visible veins",
      value: "Visible veins",
      imgURL: "visible_veins-01.jpg",
    },
    {
      text: "Diffuse Redness",
      value: "Diffuse Redness",
      imgURL: "diffuse_redness-01.jpg",
    },
    {
      text: "Reactive to new products",
      value: "Reactive to new products",
      imgURL: "reactive_newproducts-01.jpg",
    },
    { text: "Small rash", value: "Small rash", imgURL: "small_rash-01.jpg" },
    {
      text: "Peeling Skin",
      value: "Peeling Skin",
      imgURL: "peeling_skin-01.jpg",
    },
    {
      text: "Dull and oily",
      value: "Dull and oily",
      imgURL: "dull_oily-01.jpg",
    },
    { text: "Blackheads", value: "Blackheads", imgURL: "blackheads-01.jpg" },
    { text: "Acne", value: "Acne", imgURL: "acne-01.jpg" },
    { text: "Large Pores", value: "Large Pores", imgURL: "large_pores-01.jpg" },
    {
      text: 'Oily "T" zone',
      value: 'Oily "T" zone',
      imgURL: "oily_t_zone-01.jpg",
    },
    { text: "Dehydration", value: "Dehydration", imgURL: "dehydration-01.jpg" },
    { text: "Acne Scars", value: "Acne Scars", imgURL: "acne_scars-01.jpg" },
    {
      text: "Irregular skin",
      value: "Irregular skin",
      imgURL: "irregular_skin-01.jpg",
    },
    { text: "Dark Spots", value: "Dark Spots", imgURL: "dark_spots-01.jpg" },
    {
      text: "Diffused Pigment",
      value: "Diffused Pigment",
      imgURL: "diffuse_pigment-01.jpg",
    },
    {
      text: "Photosensitive",
      value: "Photosensitive",
      imgURL: "photosensitive-01.jpg",
    },
    {
      text: "Fine Wrinkles",
      value: "Fine Wrinkles",
      imgURL: "fine_wrinkles-01.jpg",
    },
    {
      text: "Deep Wrinkles",
      value: "Deep Wrinkles",
      imgURL: "deep_wrinkles-01.jpg",
    },
    {
      text: "Expression Wrinkles Disappear",
      value: "Expression Wrinkles Disappear",
      imgURL: "expression_wrinkles_disappear-01.jpg",
    },
    {
      text: "Expression Wrinkles Stay",
      value: "Expression Wrinkles Stay",
      imgURL: "expression_wrinkles_stay-01.jpg",
    },
    { text: "Discomfort", value: "Discomfort", imgURL: "discomfort-01.jpg" },
    {
      text: "Lack of elasticity",
      value: "Lack of elasticity",
      imgURL: "lack_of_elasticity-01.jpg",
    },
    {
      text: "Tugging skin",
      value: "Tugging skin",
      imgURL: "tugging_skin-01.jpg",
    },
    {
      text: "Withered skin",
      value: "Withered skin",
      imgURL: "withered_skin-01.jpg",
    },
    {
      text: "Uneven skin Tone",
      value: "Uneven skin Tone",
      imgURL: "uneven_skintone-01.jpg",
    },
  ],

  regularRoutineOptions: [
    { text: "Yes", value: true, imgURL: "routine-01.jpg" },
    { text: "No", value: false, imgURL: "no-routine-01.jpg" },
  ],

  satisfiedOptions: [
    {
      text: "Very satisfied",
      value: "Very satisfied",
      imgURL: "very-satisfied-01.jpg",
    },
    {
      text: "I wish it was better",
      value: "I wish it was better",
      imgURL: "somewhat-satisfied-01.jpg",
    },
    {
      text: "Not satisfied at all",
      value: "Not satisfied at all",
      imgURL: "not-satified-01.jpg",
    },
  ],

  multipleBrandsOptions: [
    { text: "Yes", value: true, imgURL: "multiple-brands-01.jpg" },
    { text: "No", value: false, imgURL: "same-brands-01.jpg" },
  ],

  buyingPatternOptions: [
    {
      text: "Use same products all year",
      value: "Use same products all year",
      imgURL: "change-never-01.jpg",
    },
    {
      text: "Change products sometimes",
      value: "Change products sometimes",
      imgURL: "change-sometimes-01.jpg",
    },
    {
      text: "Change products often",
      value: "Change products often",
      imgURL: "change-often-01.jpg",
    },
  ],

  choosingProductOptions: [
    {
      text: "By Yourself / Local",
      value: "By Yourself / Local",
      imgURL: "choose-byself-01.jpg",
    },
    { text: "Online", value: "Online", imgURL: "choose-online-01.jpg" },
    {
      text: "With Esthetician",
      value: "With Esthetician",
      imgURL: "choose-esthetician-01.jpg",
    },
    {
      text: "With Cosmetician",
      value: "With Cosmetician",
      imgURL: "choose-cosmetician-01.jpg",
    },
    {
      text: "With Dermatologist",
      value: "With Dermatologist",
      imgURL: "choose-dermatology-01.jpg",
    },
  ],

  activeIngrOptions: [
    { text: "Yes", value: true, imgURL: "active-ingr-yes-01.jpg" },
    { text: "No", value: false, imgURL: "active-ingr-no-01.jpg" },
  ],

  applyOrderOptions: [
    { text: "Yes", value: true, imgURL: "order-yes-01.jpg" },
    { text: "No", value: false, imgURL: "order-no-01.jpg" },
  ],
  ageOptions: [
    { text: "<18", value: "<18" },
    { text: "18-25", value: "18-25" },
    { text: "26-35", value: "26-35" },
    { text: "36-45", value: "36-45" },
    { text: "46-55", value: "46-55" },
    { text: "56-65", value: "56-65" },
    { text: "66-75", value: "66-75" },
    { text: "76+", value: "76+" },
  ],
  Picked: {
    language_code: "",
    name: "",
    email: "",
    terms: null,
    emails: null,
    age: "",
    applyOrder: null,
    activeIngr: null,
    choosingProduct: "",
    multipleBrands: null,
    buyingPattern: "",
    satisfied: "",
    regularRoutine: null,
    symptoms: [],
    concerns: [],
    products: [],
    datetime: this.datetimenow,
  },
};

const frOptions = {
  checked: [],
  productOptions: [
    {
      text: "Nettoyant",
      value: "Nettoyant",
      i: "cleanser",
      imgURL: "cleanser-01.jpg",
    },
    {
      text: "Lotion Tonique",
      value: "Lotion Tonique",
      i: "toner",
      imgURL: "toner-01-01.jpg",
    },
    { text: "Sérum", value: "Sérum", i: "serum", imgURL: "serum-01-01.jpg" },
    {
      text: "Crème de jour",
      value: "Crème de jour",
      i: "daycream",
      imgURL: "day-cream-01.jpg",
    },
    {
      text: "Crème de nuit",
      value: "Crème de nuit",
      i: "nightcream",
      imgURL: "day-cream-01.jpg",
    },
    {
      text: "Contour des yeux",
      value: "Contour des yeux",
      i: "eyecream",
      imgURL: "eye-cream-01.jpg",
    },
    {
      text: "Exfoliant",
      value: "Exfoliant",
      i: "exfoliation",
      imgURL: "exfoliation-01.jpg",
    },
    { text: "Masque", value: "Masque", i: "mask", imgURL: "mask-01.jpg" },
  ],

  concernOptions: [
    {
      text: "Rougeurs",
      value: "Rougeurs",
      i: "Redness",
      imgURL: "redness-01.jpg",
    },
    {
      text: "Imperfections / Acné",
      value: "Imperfections / Acné",
      i: "Acne",
      imgURL: "acne-01_a.jpg",
    },
    {
      text: "Teint inégal",
      value: "Teint inégal",
      i: "Uneven",
      imgURL: "uneven-01.jpg",
    },
    { text: "Rides", value: "Rides", i: "Wrinkles", imgURL: "wrinkles-01.jpg" },
    {
      text: "Peau sèche",
      value: "Peau sèche",
      i: "Dry",
      imgURL: "dry-skin-01.jpg",
    },
  ],

  symptomOptions: [
    {
      text: "Rougeurs en consommant de l’alcool",
      value: "Rougeurs en consommant de l’alcool",
      i: "Red when consuming alcohol",
      imgURL: "red_alcohol-01.jpg",
    },
    {
      text: "Veines visibles",
      value: "Veines visibles",
      i: "Visible veins",
      imgURL: "visible_veins-01.jpg",
    },
    {
      text: "Rougeurs diffuses",
      value: "Rougeurs diffuses",
      i: "Diffuse Redness",
      imgURL: "diffuse_redness-01.jpg",
    },
    {
      text: "Réaction à de nouveaux produits",
      value: "Réaction à de nouveaux produits",
      i: "Reactive to new products",
      imgURL: "reactive_newproducts-01.jpg",
    },
    {
      text: "Petits boutons",
      value: "Petits boutons",
      i: "Small rash",
      imgURL: "small_rash-01.jpg",
    },
    {
      text: "Peau qui pèle",
      value: "Peau qui pèle",
      i: "Peeling Skin",
      imgURL: "peeling_skin-01.jpg",
    },
    {
      text: "Teint terne et huileux",
      value: "Teint terne et huileux",
      i: "Dull and oily",
      imgURL: "dull_oily-01.jpg",
    },
    {
      text: "Comédons",
      value: "Comédons",
      i: "Blackheads",
      imgURL: "blackheads-01.jpg",
    },
    { text: "Acné", value: "Acné", i: "Acne", imgURL: "acne-01.jpg" },
    {
      text: "Pores élargis",
      value: "Pores élargis",
      i: "Large Pores",
      imgURL: "large_pores-01.jpg",
    },
    {
      text: "Zone “T” huileuse",
      value: "Zone “T” huileuse",
      i: 'Oily "T" zone',
      imgURL: "oily_t_zone-01.jpg",
    },
    {
      text: "Déshydratation",
      value: "Déshydratation",
      i: "Dehydration",
      imgURL: "dehydration-01.jpg",
    },
    {
      text: "Cicatrices d’acné",
      value: "Cicatrices d’acné",
      i: "Acne Scars",
      imgURL: "acne_scars-01.jpg",
    },
    {
      text: "Relief irrégulier",
      value: "Relief irrégulier",
      i: "Irregular skin",
      imgURL: "irregular_skin-01.jpg",
    },
    {
      text: "Taches pigmentaires",
      value: "Taches pigmentaires",
      i: "Dark Spots",
      imgURL: "dark_spots-01.jpg",
    },
    {
      text: "Pigmentation diffuse",
      value: "Pigmentation diffuse",
      i: "Diffused Pigment",
      imgURL: "diffuse_pigment-01.jpg",
    },
    {
      text: "Photosensibilité",
      value: "Photosensibilité",
      i: "Photosensitive",
      imgURL: "photosensitive-01.jpg",
    },
    {
      text: "Rides de surface",
      value: "Rides de surface",
      i: "Fine Wrinkles",
      imgURL: "fine_wrinkles-01.jpg",
    },
    {
      text: "Rides profondes",
      value: "ides profondes",
      i: "Deep Wrinkles",
      imgURL: "deep_wrinkles-01.jpg",
    },
    {
      text: "Rides d’expressions disparaissent",
      value: "Rides d’expressions disparaissent",
      i: "Expression Wrinkles Disappear",
      imgURL: "expression_wrinkles_disappear-01.jpg",
    },
    {
      text: "Rides d’expression restent",
      value: "Rides d’expression restent",
      i: "Expression Wrinkles Stay",
      imgURL: "expression_wrinkles_stay-01.jpg",
    },
    {
      text: "Inconfort",
      value: "Inconfort",
      i: "Discomfort",
      imgURL: "discomfort-01.jpg",
    },
    {
      text: "Manque d’élasticité",
      value: "Manque d’élasticité",
      i: "Lack of elasticity",
      imgURL: "lack_of_elasticity-01.jpg",
    },
    {
      text: "Peau floconneuse",
      value: "Peau floconneuse",
      i: "Tugging skin",
      imgURL: "tugging_skin-01.jpg",
    },
    {
      text: "Peau flétrie",
      value: "Peau flétrie",
      i: "Withered skin",
      imgURL: "withered_skin-01.jpg",
    },
    {
      text: "Teint inégal",
      value: "Teint inégal",
      i: "Uneven skin Tone",
      imgURL: "uneven_skintone-01.jpg",
    },
  ],

  regularRoutineOptions: [
    { text: "Oui", value: true, imgURL: "routine-01.jpg" },
    { text: "Non", value: false, imgURL: "no-routine-01.jpg" },
  ],

  satisfiedOptions: [
    {
      text: "Très satisfait(e)",
      value: "Très satisfait(e)",
      i: "Very satisfied",
      imgURL: "very-satisfied-01.jpg",
    },
    {
      text: "J’aimerais l’améliorer",
      value: "J’aimerais l’améliorer",
      i: "I wish it was better",
      imgURL: "somewhat-satisfied-01.jpg",
    },
    {
      text: "Très insatisfait(e)",
      value: "Très insatisfait(e)",
      i: "Not satisfied at all",
      imgURL: "not-satified-01.jpg",
    },
  ],

  multipleBrandsOptions: [
    { text: "Oui", value: true, imgURL: "multiple-brands-01.jpg" },
    { text: "Non", value: false, imgURL: "same-brands-01.jpg" },
  ],

  buyingPatternOptions: [
    {
      text: "J’utilise les mêmes produits à l’année longue",
      value: "J’utilise les mêmes produits à l’année longue",
      i: "Use same products all year",
      imgURL: "change-never-01.jpg",
    },
    {
      text: "Je change parfois de produits",
      value: "Je change parfois de produits",
      i: "Change products sometimes",
      imgURL: "change-sometimes-01.jpg",
    },
    {
      text: "Je change souvent de produits",
      value: "Je change souvent de produits",
      i: "Change products often",
      imgURL: "change-often-01.jpg",
    },
  ],

  choosingProductOptions: [
    {
      text: "Par moi-même",
      value: "Par moi-même",
      i: "By Yourself / Local",
      imgURL: "choose-byself-01.jpg",
    },
    {
      text: "En ligne",
      value: "En ligne",
      i: "Online",
      imgURL: "choose-online-01.jpg",
    },
    {
      text: "Avec une esthéticienne",
      value: "Avec une esthéticienne",
      i: "With Esthetician",
      imgURL: "choose-esthetician-01.jpg",
    },
    {
      text: "Avec une cosméticienne",
      value: "Avec une cosméticienne",
      i: "With Cosmetician",
      imgURL: "choose-cosmetician-01.jpg",
    },
    {
      text: "Avec un dermatologue",
      value: "Avec un dermatologue",
      i: "With Dermatologist",
      imgURL: "choose-dermatology-01.jpg",
    },
  ],

  activeIngrOptions: [
    { text: "Oui", value: true, imgURL: "active-ingr-yes-01.jpg" },
    { text: "Non", value: false, imgURL: "active-ingr-no-01.jpg" },
  ],

  applyOrderOptions: [
    { text: "Oui", value: true, imgURL: "order-yes-01.jpg" },
    { text: "Non", value: false, imgURL: "order-no-01.jpg" },
  ],
  ageOptions: [
    { text: "<18", value: "<18" },
    { text: "18-25", value: "18-25" },
    { text: "26-35", value: "26-35" },
    { text: "36-45", value: "36-45" },
    { text: "46-55", value: "46-55" },
    { text: "56-65", value: "56-65" },
    { text: "66-75", value: "66-75" },
    { text: "76+", value: "76+" },
  ],
  Picked: {
    language_code: "",
    name: "",
    email: "",
    terms: null,
    emails: null,
    age: "",
    applyOrder: null,
    activeIngr: null,
    choosingProduct: "",
    multipleBrands: null,
    buyingPattern: "",
    satisfied: "",
    regularRoutine: null,
    symptoms: [],
    concerns: [],
    products: [],
    datetime: this.datetimenow,
  },
};

export default {
  name: "online-skincare-assessment",
  components: {
    choiceToggle,
  },
  data() {
    return {
      code: "",
      validcode: false,
      submitting: false,
      current_step: 1,
      max_step: 11,
      form: "",
    };
  },
  methods: {
    getData() {
      if (this.$i18n.locale == "fr") {
        this.form = frOptions;
        this.form.language_code = "fr";
      } else this.form = enOptions;
      this.form.language_code = "en";
    },
    IsInList(x, l) {
      var length = l.length;
      for (var i = 0; i < length; i++) {
        if (l[i] == x.value) return true;
      }
    },
    choicePic(c) {
      this.productPicked.push();
    },
    checkCode() {
      this.validcode = true;
    },
    onClickNext: function () {
      this.current_step++;
    },
    onClickBack: function () {
      this.current_step--;
    },
    onClickFirst: function () {
      this.current_step = 1;
    },
    datetimenow: function () {
      var currentDate = new Date();
      this.form.Picked.datetimenow = currentDate;
    },
    SubmitQuiz(evt) {
      evt.preventDefault();
      this.submitting = true;
      this.postAssessment();
    },
    postAssessment() {
      let data = this.form.Picked;
      // axios.post('http://127.0.0.1:8000/api/assessment', data)
      axios
        .post("https://api.beauteintegrale.ca/submissions/assessments", data)
        .then((resp) => {
          mutations.setAssessment(resp.data.result);
          this.submitting = false;
          this.$router.push({ name: "OnlineAssessmentResults" });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },

  computed: {
    locale() {
      return this.$i18n.locale;
    },
    progress: function () {
      return Math.round(100 / this.max_step) * this.current_step;
    },
    buttonaction1: function () {
      if (
        this.form.Picked.name.length > 2 &&
        this.form.Picked.terms &&
        this.form.Picked.emails
      ) {
        return false;
      } else return true;
    },
    buttonaction2: function () {
      if (this.form.Picked.products.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction3: function () {
      if (this.form.Picked.concerns.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction4: function () {
      if (this.form.Picked.symptoms.length >= 1) {
        return false;
      } else return true;
    },
    buttonaction5: function () {
      if (this.form.Picked.regularRoutine !== null) {
        return false;
      } else return true;
    },
    buttonaction6: function () {
      if (this.form.Picked.satisfied.length > 1) {
        return false;
      } else return true;
    },
    buttonaction7: function () {
      if (this.form.Picked.multipleBrands !== null) {
        return false;
      } else return true;
    },
    buttonaction8: function () {
      if (this.form.Picked.buyingPattern.length > 1) {
        return false;
      } else return true;
    },
    buttonaction9: function () {
      return false;
    },
    buttonaction10: function () {
      if (this.form.Picked.applyOrder !== null) {
        return false;
      } else return true;
    },
    buttonaction11: function () {
      if (this.form.Picked.choosingProduct.length > 1) {
        return false;
      } else return true;
    },
    buttonaction12: function () {
      if (
        this.form.Picked.age.length > 1 &&
        this.form.Picked.email.length > 1 &&
        this.form.Picked.email.includes("@")
      ) {
        return false;
      } else return true;
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    locale: function (newLocale, oldLocale) {
      this.getData();
      this.current_step = 1;
    },
  },
};
</script>

<style scoped>
.mycontainer-main {
  min-height: calc(80vh - 10vh);
}
.bar {
  animation-duration: 3s;
  animation-name: slidein;
  background-color: black;
  height: 25px;
  margin-bottom: 25px;
  margin-left: 25vw;
  margin-right: 25vw;
}
.animate-left {
  animation-duration: 3s;
  animation-name: slidein;
}

@keyframes slidein {
  from {
    margin-right: 100%;
  }

  to {
    margin-right: 25%;
  }
}
h1 {
  font-size: 10vh;
  font-weight: 900;
  color: white;
}
.main-button {
  width: 175px;
}
.custom-control-label:after {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("../assets/images/retail-clinic.jpg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: "cover";
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-color: red !important;
}
.active img {
  box-shadow: 5px 10px 8px rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.2);
  border: solid #36a8eb 2px;
  /* border-radius: 50%; */
  opacity: 0.7;
}
.active p {
  color: #36a8eb;
  font-weight: 900;
}

.main-assessment-img {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)),
    url("../assets/images/background1.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  min-height: 40vh;
}
.mid {
  padding-top: 10vh;
}
.btn.disabled,
.btn:disabled {
  opacity: 0.15;
}
</style>



// WEBPACK FOOTER //
// src/pages/OnlineAssessmentRoutine.vue